import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoIosAddCircleOutline } from "react-icons/io";
import { setDialog } from "../../../../app/slices/leaveUserSlice";
import LeaveForm from "../../from";
import LeaveCancelForm from "../../cancel";

const LeaveHeader = () => {
  const _Leave = useSelector((state) => state.leaveUser);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            طلبات الاجازة
          </Typography>
        }
        avatar={<FaRegCalendarAlt size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة
          </Button>
        }
      />
      {_Leave.leave.dialog ? <LeaveForm /> : null}
      {_Leave.cancel.dialog ? <LeaveCancelForm /> : null}
    </Card>
  );
};

export default LeaveHeader;
